import { useEffect, useRef } from "preact/hooks"
import { MenuProvider, useMenuContext } from "../context/menu-context"
import { qs } from "../util/dom"
import { keyEventHandling } from "../util/key-events"
import { ContentType } from "./contents/content-type"
import { Icon } from "./contents/icon"
import { Message } from "./message"

const mainEl = qs("main")

export const Menu = (props) => {
  return (
    <MenuProvider ep={props.ep} contactEp={props.contactEp}>
      <MenuContent />
    </MenuProvider>
  )
}

const MenuContent = () => {
  const { data, loading, current, navShown, messageData, toggleNav } =
    useMenuContext()
  const navRef = useRef("")

  useEffect(() => {
    keyEventHandling(window, "Escape", () => {
      navShown && toggleNav()
    })
  })

  useEffect(() => {
    setTimeout(() => {
      mainEl.style.display = navShown ? "none" : "block"
      if (navRef.current && !navShown) navRef.current.style.display = "none"
    }, 400)
    if (navRef.current && navShown) navRef.current.style.display = "block"
  }, [navShown])

  // useLayoutEffect(() => {
  //   const resizeNav = (_e) => {
  //     if (!navShown)
  //       navRef.current.style = `--el-height: ${navRef.current.offsetHeight}px`
  //   }
  //   resizeNav()
  //   window.addEventListener("resize", resizeNav)
  // })

  return (
    <>
      <button
        type="button"
        class="button nav-toggle open-button"
        aria-controls="nav-menu"
        onClick={toggleNav}
        aria-label="open navigation"
        disabled={navShown}
      >
        <Icon name="burger" />
      </button>
      <nav ref={navRef} id="nav-menu" class={`menu ${navShown && "expanded"}`}>
        <div class="container menu__inner">
          <ul class="language-nav">
            <li>
              <a
                href="/de/"
                class={document.documentElement.lang === "de" ? "active" : ""}
              >
                DE
              </a>
            </li>
            <li>
              <a
                href="/en/"
                class={document.documentElement.lang === "en" ? "active" : ""}
              >
                EN
              </a>
            </li>
            <li>
              <a
                href="/fr/"
                class={document.documentElement.lang === "fr" ? "active" : ""}
              >
                FR
              </a>
            </li>
          </ul>
          <button
            type="button"
            class="button nav-toggle close-button"
            aria-controls="nav-menu"
            onClick={toggleNav}
            aria-label="close navigation"
            aria-haspopup="true"
          >
            <Icon name="close" />
          </button>
          {messageData && <Message data={messageData} />}
          {!loading &&
            data.length > 0 &&
            (current === "" ? <MenuLinks /> : <MenuOverlay />)}
        </div>
      </nav>
    </>
  )
}

export const MenuLinks = () => {
  const { data, setCurrent, languageCode } = useMenuContext()

  return (
    <ul>
      {data.map((link) => {
        const cityPostfix = link?.city ? `?city=${link.city}` : ""
        return (
          <li key={link.slug}>
            <a
              role="menuitem"
              href={`/${languageCode}/${link.slug}/${cityPostfix}`}
              onClick={(e) => {
                e.preventDefault()
                setCurrent(link.slug)
              }}
            >
              {link.title}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export const MenuOverlay = () => {
  const context = useMenuContext()
  const { data, current, setCurrent, languageCode } = context
  const page = current !== "" ? data.find((d) => d.slug === current) : false

  return (
    <div class="menu-page-overlay">
      <div class="menu-backlink-wrap">
        <a
          role="menuitem"
          class="menu-backlink"
          href={`/${languageCode}/`}
          onClick={(e) => {
            e.preventDefault()
            setCurrent("")
          }}
        >
          <Icon name="arrow-back" />
          {page.backlink}
        </a>
      </div>
      {page.contents?.map((obj, i) => {
        return (
          <ContentType
            {...obj}
            context={context}
            key={`menu-page-overlay-${obj.type}-${i}`}
          />
        )
      })}
    </div>
  )
}
